export enum PlanningTruckStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE',
  NotReady = 'NOT_READY',
  Assigned = 'ASSIGNED',
}
